export default "__VITE_ASSET__CaHfVD8L__"